import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FloatingActionButton, MuiThemeProvider } from 'material-ui';
import ActionCode from 'material-ui/svg-icons/action/code';
import {
  onLeftPostalOperatorChecked,
  onRightPostalOperatorChecked,
  onSelectAllLeftPostalOperators,
  onSelectAllRightPostalOperators,
  onUnselectAllLeftPostalOperators,
  onUnselectAllRightPostalOperators,
  retrieveAllLeftOperatorsRequestActionCreator,
  retrieveAllRightOperatorsRequestActionCreator,
  retrieveLeftGlobalOperatorPresetRequestActionCreator,
  retrieveLeftOperatorsByRoleRequestActionCreator,
  retrieveRightGlobalOperatorPresetRequestActionCreator,
  retrieveRightOperatorsByRoleRequestActionCreator,
} from '../redux/actions/OperatorImpcActions';
import OperatorSelectionSelector from '../redux/selectors/OperatorSelectionSelector';
import { getAssetType } from '../../../asset-types/redux/selectors/AssetTypesSelectors';
import {
  getLeftCheckedPostalOperators,
  getLeftPostalOperators,
  getRightCheckedPostalOperators,
  getRightPostalOperators,
} from '../../../user/redux/selectors/UserDataSelectors';

class OperatorSelectionContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const leftParams = {
      assetType: this.props.appContext.appContext,
      useGlobalPresets: this.props.leftTree.useGlobalPresets,
    };
    if (this.props.leftTree.roleFilter === true) {
      this.props.retrieveLeftOperatorsByRoleRequestActionCreator(leftParams);
    } else {
      this.props.retrieveAllLeftOperatorsRequestActionCreator(leftParams);
    }

    if (this.props.rightTree) {
      const rightParams = {
        assetType: this.props.appContext.appContext,
        useGlobalPresets: this.props.rightTree.useGlobalPresets,
      };
      if (this.props.rightTree.roleFilter) {
        this.props.retrieveRightOperatorsByRoleRequestActionCreator(rightParams);
      } else {
        this.props.retrieveAllRightOperatorsRequestActionCreator(rightParams);
      }
    }
  }

  onSelectLeft = (selected) => {
    this.props.onLeftPostalOperatorChecked(selected);
  };

  onSelectRight = (selected) => {
    this.props.onRightPostalOperatorChecked(selected);
  };

  onSelectAllLeft = () => {
    this.props.onSelectAllLeftPostalOperators(this.props.leftTree.postalOperatorNodes);
  };

  onSelectAllRight = () => {
    this.props.onSelectAllRightPostalOperators(this.props.rightTree.postalOperatorNodes);
  };

  onUnselectedAllLeft = () => {
    this.props.onUnselectAllLeftPostalOperators();
  };

  onUnselectedAllRight = () => {
    this.props.onUnselectAllRightPostalOperators();
  };

  onSelectLeftContextType = () => {
    this.props.retrieveLeftGlobalOperatorPresetRequestActionCreator(this.props.appContext.appContext);
  }

  onSelectRightContextType = () => {
    this.props.retrieveRightGlobalOperatorPresetRequestActionCreator(this.props.appContext.appContext);
  }

  render() {
    return (
      <div>
        <div className="operator-div">
          <OperatorSelectionSelector
            title={this.props.leftTree.title}
            postalOperatorNodes={this.props.leftTree.postalOperatorNodes}
            checked={this.props.leftTree.checkedPostalOperators}
            onCheck={this.onSelectLeft}
            onSelectAll={this.onSelectAllLeft}
            onDeSelectAll={this.onUnselectedAllLeft}
            appContextType={this.props.appContext.appContext}
            onContextClick={this.onSelectLeftContextType}
            expandDisabled
          />
          {this.props.rightTree && this.props.switchEnabled && (
            <div className="operator-divider">
              <MuiThemeProvider>
                <FloatingActionButton
                  onClick={this.onSwitchInboundOutbound}
                  backgroundColor="#03adaa"
                  mini
                  style={{
                    zIndex: 1,
                    marginLeft: '-20px',
                    marginTop: '11px',
                    border: '5px solid #abe1e5',
                    boxShadow: 'none',
                  }}
                >
                  <ActionCode />
                </FloatingActionButton>
              </MuiThemeProvider>
            </div>
          )}
          {this.props.rightTree && (
            <OperatorSelectionSelector
              title={this.props.rightTree.title}
              postalOperatorNodes={this.props.rightTree.postalOperatorNodes}
              checked={this.props.rightTree.checkedPostalOperators}
              onCheck={this.onSelectRight}
              onSelectAll={this.onSelectAllRight}
              onDeSelectAll={this.onUnselectedAllRight}
              appContextType={this.props.appContext.appContext}
              onContextClick={this.onSelectRightContextType}
              expandDisabled
            />
          )}
        </div>
      </div>
    );
  }
}

OperatorSelectionContainer.propTypes = {
  retrieveLeftOperatorsByRoleRequestActionCreator: PropTypes.func,
  retrieveRightOperatorsByRoleRequestActionCreator: PropTypes.func,
  retrieveAllLeftOperatorsRequestActionCreator: PropTypes.func,
  retrieveAllRightOperatorsRequestActionCreator: PropTypes.func,
  retrieveLeftGlobalOperatorPresetRequestActionCreator: PropTypes.func,
  retrieveRightGlobalOperatorPresetRequestActionCreator: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.shape),
  leftTree: PropTypes.shape({
    roleFilter: PropTypes.bool,
    title: PropTypes.string,
    useGlobalPresets: PropTypes.bool,
    postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
    checkedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  }),
  rightTree: PropTypes.shape({
    roleFilter: PropTypes.bool,
    title: PropTypes.string,
    useGlobalPresets: PropTypes.bool,
    postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
    checkedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  }),
  onLeftPostalOperatorChecked: PropTypes.func,
  onRightPostalOperatorChecked: PropTypes.func,
  onSelectAllLeftPostalOperators: PropTypes.func,
  onSelectAllRightPostalOperators: PropTypes.func,
  onUnselectAllLeftPostalOperators: PropTypes.func,
  onUnselectAllRightPostalOperators: PropTypes.func,
  switchEnabled: PropTypes.bool,
};

OperatorSelectionContainer.defaultProps = {
  leftTree: {
    roleFilter: true,
    title: 'OPERATORS',
    useGlobalPresets: true,
  },
  switchEnabled: false,
};

function mapStateToProps(state, props) {
  let newProps = {
    appContext: getAssetType(state),
    leftTree: {
      ...OperatorSelectionContainer.defaultProps.leftTree,
      ...props.leftTree,
      postalOperatorNodes: getLeftPostalOperators(state),
      checkedPostalOperators: getLeftCheckedPostalOperators(state),
    },
  };

  if (props.rightTree) {
    newProps = {
      ...newProps,
      rightTree: {
        ...props.rightTree,
        postalOperatorNodes: getRightPostalOperators(state),
        checkedPostalOperators: getRightCheckedPostalOperators(state),
      },
    };
  }

  return newProps;
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  retrieveLeftOperatorsByRoleRequestActionCreator,
  retrieveRightOperatorsByRoleRequestActionCreator,
  retrieveAllLeftOperatorsRequestActionCreator,
  retrieveAllRightOperatorsRequestActionCreator,
  retrieveLeftGlobalOperatorPresetRequestActionCreator,
  retrieveRightGlobalOperatorPresetRequestActionCreator,
  onLeftPostalOperatorChecked,
  onRightPostalOperatorChecked,
  onSelectAllLeftPostalOperators,
  onSelectAllRightPostalOperators,
  onUnselectAllLeftPostalOperators,
  onUnselectAllRightPostalOperators,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OperatorSelectionContainer);
